import countrycitystate from 'countrycitystatejson'

export function sortAlpha(values, keyFn = (value) => value) {
  return [...values].sort((a, b) =>
    keyFn(a).localeCompare(keyFn(b), undefined, { sensitivity: 'base' })
  )
}

export function buildListCountries(customLocations) {
  const packageCountries = countrycitystate.getCountries()
  const byName = new Map()
  packageCountries.forEach((entry) => {
    byName.set(entry.name.trim().toLowerCase(), {
      name: entry.name,
      shortName: entry.shortName,
    })
  })
  ;(customLocations || []).forEach((location) => {
    const key = String(location.country || '').trim().toLowerCase()
    if (!key || byName.has(key)) {
      return
    }
    byName.set(key, {
      name: String(location.country).trim(),
      shortName: String(location.shortName || '').trim(),
    })
  })
  return sortAlpha([...byName.values()], (entry) => entry.name)
}

export function buildCountryNames(listCountries) {
  return sortAlpha(
    listCountries.map((entry) => entry.name),
    (value) => value
  )
}

export function buildStates(listCountries, country, customLocations) {
  const normalizedCountry = String(country || '')
    .trim()
    .toLowerCase()
  const index = listCountries.findIndex((entry) => entry.name === country)
  let states = []
  if (index >= 0 && listCountries[index].shortName) {
    states =
      countrycitystate.getStatesByShort(listCountries[index].shortName) || []
  }
  const customStates = (customLocations || [])
    .filter(
      (location) =>
        String(location.country || '')
          .trim()
          .toLowerCase() === normalizedCountry
    )
    .map((location) => String(location.state || '').trim())
    .filter(Boolean)
  const merged = [
    ...new Set(
      [...states, ...customStates].map((value) => String(value).trim())
    ),
  ].filter(Boolean)
  return sortAlpha(
    merged.filter((state) => state.length > 2),
    (value) => value
  )
}

export function buildCities(
  listCountries,
  country,
  state,
  customLocations,
  asTextObjects = false
) {
  const normalizedCountry = String(country || '')
    .trim()
    .toLowerCase()
  const normalizedState = String(state || '')
    .trim()
    .toLowerCase()
  const index = listCountries.findIndex((entry) => entry.name === country)
  let cities = []
  if (index >= 0 && listCountries[index].shortName && state) {
    cities =
      countrycitystate.getCities(listCountries[index].shortName, state) || []
  }
  const customCities = (customLocations || [])
    .filter(
      (location) =>
        String(location.country || '')
          .trim()
          .toLowerCase() === normalizedCountry &&
        String(location.state || '')
          .trim()
          .toLowerCase() === normalizedState
    )
    .map((location) => String(location.city || '').trim())
    .filter(Boolean)
  const merged = [
    ...new Set(
      [...cities, ...customCities].map((value) => String(value).trim())
    ),
  ].filter(Boolean)
  const sorted = sortAlpha(merged, (value) => value)
  if (asTextObjects) {
    return sorted.map((city) => ({ text: city }))
  }
  return sorted
}

export function resolveShortName(listCountries, country) {
  const index = listCountries.findIndex((entry) => entry.name === country)
  if (index < 0) {
    return ''
  }
  return listCountries[index].shortName || ''
}
